import { DateTime } from 'luxon';

export const formatDateToMed = (dateISO: string) =>
  DateTime.fromISO(dateISO).toLocaleString(DateTime.DATE_MED);
